module.exports = __webpack_public_path__ + "static/media/018_A - 2 - SIGN IN first time.fd7f4c17.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/kp/018_A - 2 - SIGN IN first time.png
// module id = 515
// module chunks = 0